<template>
    <el-dialog
            title="圆点放大显示"
            :visible.sync="circleVisable"
            append-to-body
            width="400px"
            :before-close="handleClose"
        >
        <div class="radioList-type">
            <el-radio v-model="circleCheck" class="radio-type" :label="1">包装数&nbsp;&nbsp;&nbsp;&nbsp;≥</el-radio>
            <el-input
                v-model.trim="config.totalPackageQuantity"
                clearable
                maxlength="10"
                :disabled="circleCheck!==1"
                placeholder="范围20-1000的整数"
                @blur="validatePackageNum"
                />
        </div>
        <div class="radioList-type">
            <el-radio v-model="circleCheck" :label="2" class="radio-type">方量&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;≥</el-radio>
            <el-input
                v-model.trim="config.totalVolume"
                clearable
                maxlength="10"
                :disabled="circleCheck!==2"
                placeholder="范围1-50的数字"
                @blur="validateQty"
                />
        </div>
        <div slot="footer">
            <el-button @click="handleClose">取消</el-button>
            <el-button type="primary" @click="handleSure">保存</el-button>
        </div>
        </el-dialog>
</template>
<script>
import { mapState } from 'vuex';
export default {
    data () {
        return {
            circleCheck: 1,
            config: {
                totalPackageQuantity: '',
                totalVolume: ''
            },
            circleVisable: false
        };
    },
    watch: {
        circleCheck (val) {
            if (val === 1) {
                this.config.totalVolume = '';
            }
            if (val === 2) {
                this.config.totalPackageQuantity = '';
            }
        },
        circleVisable (val) {
            if (val) {
                this.circleCheck = 1;
                this.config.totalPackageQuantity = '';
                this.config.totalVolume = '';
                this.loadStoredValues();
            }
        }
    },
    computed: {
        ...mapState({
            user: state => state.user
        })
    },
    methods: {
        handleClose () {
            this.circleVisable = false;
        },
        handleSure () {
            this.$emit('setCircleSize', this.config);
            this.circleVisable = false;
        },
        // 从统一key中取出对应账号的数据
        loadStoredValues () {
            try {
                const key = 'circleSize';
                const allUserData = localStorage.getItem(key);

                if (allUserData) {
                    const parsedData = JSON.parse(allUserData);
                    const userCode = this.user.userCode;
                    // 获取当前用户的数据
                    const userData = parsedData[userCode];
                    if (userData) {
                        // 如果有存储的值，则赋值给对应的字段
                        if (userData.totalPackageQuantity) {
                            this.circleCheck = 1;
                            this.config.totalPackageQuantity = userData.totalPackageQuantity;
                        }
                        if (userData.totalVolume) {
                            this.circleCheck = 2;
                            this.config.totalVolume = userData.totalVolume;
                        }
                    } else {
                        this.circleCheck = 1;
                        this.config.totalPackageQuantity = '';
                        this.config.totalVolume = '';
                    }
                } else {
                    this.circleCheck = 1;
                    this.config.totalPackageQuantity = '';
                    this.config.totalVolume = '';
                }
            } catch (error) {

            }
        },

        validatePackageNum () {
            if (this.config.totalPackageQuantity === '') return;

            const cleanValue = this.config.totalPackageQuantity.replace(/^0+/, '');
            if (cleanValue === '') {
                this.config.totalPackageQuantity = '';
                return;
            }

            const num = parseInt(cleanValue);
            if (isNaN(num)) {
                this.config.totalPackageQuantity = '';
                return;
            }
            if (num < 20) {
                this.config.totalPackageQuantity = '20';
            } else if (num > 1000) {
                this.config.totalPackageQuantity = '1000';
            } else {
                this.config.totalPackageQuantity = num.toString();
            }
        },

        validateQty () {
            if (this.config.totalVolume === '') return;

            let cleanValue = this.config.totalVolume.replace(/^0+/, '');
            if (cleanValue === '') {
                this.config.totalVolume = '';
                return;
            }

            if (cleanValue.startsWith('.')) {
                cleanValue = '0' + cleanValue;
            }

            const num = parseFloat(cleanValue);
            if (isNaN(num)) {
                this.config.totalVolume = '';
                return;
            }

            if (num < 1) {
                this.config.totalVolume = '1';
            } else if (num > 50) {
                this.config.totalVolume = '50';
            } else {
                // 格式化数字，移除不必要的前导零
                this.config.totalVolume = num.toString();
            }
        }
    }
};
</script>
<style lang="less" scoped>
.radioList-type {
    font-size: 14px;
    display: flex;
    align-items: center;
    margin:0 0 15px 0;

    .radio-type {
       width: 60px;
    }
}

.el-input {
    width: 150px;
}
</style>
